var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaybybank = function SvgPaybybank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 -20 200 300",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 167.5H64.6c-5.6 0-10.2-4.6-10.2-10.2 0-.5 0-1 .1-1.4 0-1.9.5-3.9 1.6-5.6l46.3-71.5h-80c-1.1 0-2 .9-2 2v111.9c0 1.1.9 2 2 2h57.2c1.1 0 2-.9 2-2v-7.5c0-2.3 1.8-4.1 4.1-4.1H98c2.3 0 4.1 1.8 4.1 4.1v25.9c0 6-4.9 10.9-10.9 10.9H10.9c-6 0-10.9-4.9-10.9-10.9V69.3c0-6 4.9-10.9 10.9-10.9h109.5c5.6 0 10.2 4.6 10.2 10.2 0 .5 0 1-.1 1.4 0 1.9-.5 3.9-1.6 5.6L82.6 147h78.7c1.1 0 2-.9 2-2V26.3c0-1.1-.9-2-2-2h-57.2c-1.1 0-2 .9-2 2v14.3c0 2.3-1.8 4.1-4.1 4.1H85.8c-2.3 0-4.1-1.8-4.1-4.1V14.7c0-6 4.9-10.9 10.9-10.9h80.3c6 0 10.9 4.9 10.9 10.9v141.9c-.1 6-5 10.9-11 10.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 213.9c3 0 5.4-2.4 5.4-5.4 0-3-2.4-5.4-5.4-5.4-3 0-5.4 2.4-5.4 5.4-.1 2.9 2.4 5.4 5.4 5.4Z",
    fill: "#FFF"
  })));
};
export default SvgPaybybank;